module.exports = __webpack_public_path__ + "static/media/policy-default.3b210c76.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resource/img/policy-default.svg
// module id = 420
// module chunks = 0